import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { Link } from '@xing-com/link';
import {
  scale150,
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  spaceXXL,
  space3XL,
  xdlColorInfoSoft,
  xdlColorText,
} from '@xing-com/tokens';
import { Hero, Headline, BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  margin: ${space3XL} 0 calc(2 * ${spaceXXL});
  text-align: center;

  @media ${mediaConfined} {
    display: flex;
    margin: calc(2 * ${spaceXXL}) 0 calc(2 * ${spaceXXL});
    text-align: left;

    & > img {
      margin-right: ${space3XL};
    }
  }
`;

export const Image = styled.img`
  height: 254px;
  margin-bottom: ${scale150};
  width: 240px;

  @media ${mediaConfined} {
    height: 440px;
    margin-bottom: 0;
    width: 397px;
  }
`;

export const RightWrapper = styled.div`
  @media ${mediaConfined} {
    margin-top: 85px;

    & > a {
      margin-top: 0;
    }
  }
`;

export const TitleHandheld = styled(Headline)`
  margin-bottom: ${spaceL};
`;

export const TitleDesktop = styled(Hero)`
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    margin-top: ${spaceL};
  }
`;

export const InsightsWrapper = styled.span`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  row-gap: ${spaceM};

  & > span {
    margin-right: ${spaceM};
  }

  @media ${mediaConfined} {
    display: flex;
    justify-content: flex-start;

    & > span:not(:last-child) {
      margin-right: ${spaceXL};
    }
  }
`;

export const Insight = styled.span`
  align-items: center;
  display: flex;

  & > svg {
    margin-right: ${spaceS};
  }
`;

export const StyledLink = styled(Link)`
  color: black;

  &:hover,
  &:active,
  &:visited {
    text-decoration: none;
  }
`;

export const InsightBodyCopy = styled(BodyCopy)`
  color: ${xdlColorText};

  &:hover {
    font-weight: 700;
  }
`;

export const ArticleTypeTagsWrapper = styled.span`
  display: flex;

  & > :first-child {
    margin-right: ${spaceM};
  }
`;

export const ArticleTypeTag = styled.span`
  background-color: ${xdlColorInfoSoft};
  border-radius: 100px;
  padding: 0 ${spaceS};
`;
